import React, { Fragment } from 'react';
import classNames from 'classnames';
import './video.scss';
import { iOS } from '../../utils/browser';
interface IVideoProps {
  src?: string;
  nextSrc?: string;
}

class Video extends React.Component<IVideoProps> {
  public video: HTMLVideoElement;
  public nextVideo: HTMLVideoElement;

  componentDidMount() {
    if (this.video) {
      this.video.setAttribute('muted', '1');
    }
  }

  componentWillUnmount() {
    if (this.video) {
      this.video.pause();
      this.video.src = '';
    }
  }

  public render() {
    return (
      <Fragment>
        {iOS() === false || (iOS() && iOS() >= 9.4) ? (
          <Fragment>
            <video
              ref={ref => (this.video = ref)}
              id="video"
              src={`/images/animations/${this.props.src}`}
              autoPlay
              loop
              muted
              playsInline
              className={classNames('c-video o-ratio__content', {})}
            />
            <video
              ref={ref => (this.nextVideo = ref)}
              id="video"
              src={`/images/animations/${this.props.nextSrc}`}
              className="u-hidden-visually"
            />
          </Fragment>
        ) : (
          <Fragment>
            <div className={classNames('c-video o-ratio__content', {})}>
              <img
                src={`/images/animations/${this.props.src.replace(
                  'mp4',
                  'gif'
                )}`}
                className={classNames('c-video--fallback')}
              />
            </div>

            <img
              src={`/images/animations/${this.props.nextSrc.replace(
                'mp4',
                'gif'
              )}`}
              className="u-hidden-visually"
            />
          </Fragment>
        )}
      </Fragment>
    );
  }
}

export default Video;



// WEBPACK FOOTER //
// ./src/components/video/video.tsx